export default "__VITE_ASSET__66Ho90uc__"